import { ReactNode } from 'react'
import { Stack, Text } from '@fluentui/react'

type StatCardProps = {
  title: string
  value: string
  color: string
  children?: ReactNode
}

const StatCard = ({ title, value, color, children }: StatCardProps) => (
  <Stack
    styles={{
      root: {
        flex: 1,
        minWidth: 160,
        padding: '20px 24px',
        backgroundColor: '#fff',
        borderRadius: 8,
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        borderTop: `3px solid ${color}`,
      },
    }}
    tokens={{ childrenGap: 8 }}
  >
    <Text variant="small" styles={{ root: { color: '#605e5c', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' } }}>
      {title}
    </Text>
    <Text variant="xxLarge" styles={{ root: { fontWeight: 700, color } }}>
      {value}
    </Text>
    {children}
  </Stack>
)

export default StatCard
